import classnames from 'classnames'
import React from 'react'
import './Count.css'
import {NullAsDefault} from "../../views/Shared";

const Count = ({
                   defaultNumber,
                   type,
                   component: Icon = NullAsDefault,
                   render,
                   active,
                   color,
                   onClick,
                   className,
                   children,
                   ...props
               }) => {
    return (
        <div
            className={classnames(
                'FeedCount cursor-pointer flex items-center gap-1 px-2',
                className,
                color,
                {active}
            )}
            {...props}>
            <button
                onClick={onClick}
                className="FeedCountButton no-border">
                {Icon && (
                    <Icon size={17}
                          role="img"
                          className="FeedCountIcon"
                    />
                )}
                {render && render()}
                {children}
            </button>
            {!!defaultNumber && (
                <span
                    onClick={onClick}
                    className={classnames(
                        'relative leading-snug ml-1 font-bold text-xs',
                        className
                    )}>
                    {`${defaultNumber === null ? 0 : Number(defaultNumber).toLocaleString()}`}
                </span>
            )}
        </div>
    )
}
export default Count
